export default __webpack_public_path__ + "static/media/feature-extension.c89accba.jpg";